import { THEMES, type ThemeId } from '~/composables/useTheme'

const STORAGE_KEY = 'clinica-theme'
const DARK_THEMES: ThemeId[] = ['dark', 'glass']

// Aplica o tema salvo antes de qualquer componente renderizar,
// evitando o flash branco ao navegar para páginas de auth.
export default defineNuxtPlugin(() => {
  const stored = localStorage.getItem(STORAGE_KEY) as ThemeId | null
  const valid = stored && THEMES.some((t) => t.id === stored)
  const theme: ThemeId = valid ? (stored as ThemeId) : 'light'
  const dark = DARK_THEMES.includes(theme)

  document.documentElement.setAttribute('data-theme', theme)
  if (dark) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
})
